module.exports = __webpack_public_path__ + "static/media/april_avatar.bb8c0e24.png";